import request from '@/utils/request'

// 项目中心查询
export function getProjectCenter(data) {
  return request({
    url: '/projectCenter/selectProjectCenter',
    method: 'post',
    data
  })
}

// 模糊查询公司全称
export function getCompanyNameList(data) {
  return request({
    url: '/company/getCompanyNames',
    method: 'post',
    params: data
  })
}

// 项目中心新增
export function addProjectCenter(data) {
  return request({
    url: '/projectCenter/save',
    method: 'post',
    data
  })
}

// 项目中心修改
export function updateProjectCenter(data) {
  return request({
    url: '/projectCenter/update',
    method: 'post',
    data
  })
}

// 根据id查询项目
export function getProjectCenterById(data) {
  return request({
    url: '/projectCenter/selectBYId',
    method: 'get',
    params: data
  })
}
//修改项目状态
export function updateStatus(data) {
  return request({
    url: '/projectCenter/updateStatus',
    method: 'get',
    params: data
  })
}


// 项目中心删除
export function deleteProjectCenter(data) {
  return request({
    url: '/projectCenter/delete',
    method: 'post',
    data
  })
}

// 查询所有企业
export function getAllCompany(data) {
  return request({
    url: '/company/selectCompanyFullName',
    method: 'get',
    params: data
  })
}

// 根据企业名称查询信息
export function getInfoByCompanyName(data) {
  return request({
    url: '/projectCenter/selectCompany',
    method: 'get',
    params: data
  })
}

// 查询沟通列表
export function getCommunication(data) {
  return request({
    url: '/projectCenter/selectIntermediate',
    method: 'post',
    data
  })
}

// 查询全网搜索
export function getMatch(data) {
  return request({
    url: '/esPerson/getPerson',
    method: 'post',
    data
  })
}

// 查询人岗匹配
export function getPeoplePost(data) {
  return request({
    url: '/esPerson/getPeoplePost',
    method: 'post',
    data
  })
}

// 添加到沟通列表
export function addToCommunication(data) {
  return request({
    url: '/projectCenter/saveIntermediate',
    method: 'post',
    data
  })
}

// 添加话术管理
export function addVerbalTrick(data) {
  return request({
    url: '/ScriptManagementService/save',
    method: 'post',
    data
  })
}

// 修改话术管理
export function updateVerbalTrick(data) {
  return request({
    url: '/ScriptManagementService/update',
    method: 'post',
    data
  })
}

// 查询话术管理
export function getVerbalTrick(data) {
  return request({
    url: '/ScriptManagementService/selectScriptManagement',
    method: 'get',
    params: data
  })
}

// 删除话术管理
export function deleteVerbalTrick(data) {
  return request({
    url: '/ScriptManagementService/delete',
    method: 'get',
    params: data
  })
}

// 查询企业
export function getEnterprise(data) {
  return request({
    url: '/RelationshipTable/getCompanyByFullNameList',
    method: 'get',
    params: data
  })
}

// 查询目标企业
export function getTargetEnterprise(data) {
  return request({
    url: '/RelationshipTable/selectRelationshipTable',
    method: 'get',
    params: data
  })
}

// 添加目标企业
export function addTargetEnterprise(data) {
  return request({
    url: '/RelationshipTable/save',
    method: 'post',
    data
  })
}

// 删除目标企业
export function deleteTargetEnterprise(data) {
  return request({
    url: '/RelationshipTable/delete',
    method: 'get',
    params: data
  })
}

// 查看人才推荐报告
export function getTalentRecommend(data) {
  return request({
    url: '/talentRecommendationReport/selectByid',
    method: 'get',
    params: data
  })
}

// 添加人才推荐报告
export function addTalentRecommend(data) {
  return request({
    url: '/talentRecommendationReport/save',
    method: 'post',
    data
  })
}

// 查看背景调查报告
export function getReferenceCheck(data) {
  return request({
    url: '/BackgroundInvestigationReport/selectById',
    method: 'get',
    params: data
  })
}

// 添加背景调查报告
export function addReferenceCheck(data) {
  return request({
    url: '/BackgroundInvestigationReport/save',
    method: 'post',
    data
  })
}

// 查看公司信息
export function getCompanyInfo(data) {
  return request({
    url: '/talentRecommendationReport/getProjectCenter',
    method: 'get',
    params: data
  })
}

// 修改人才进度
export function updateTalentProgress(data) {
  return request({
    url: '/projectCenter/updateTalentProgress',
    method: 'post',
    data
  })
}

// 修改优先级别
export function updatePriority(data) {
  return request({
    url: '/projectCenter/updatePriority',
    method: 'post',
    data
  })
}

// 冻结与解冻
export function updateFreezeState(data) {
  return request({
    url: '/projectCenter/updateFreezeState',
    method: 'get',
    params: data
  })
}

// 新版-查询一览
export function selectProjectCenterTwo(data) {
  return request({
    url: '/projectCenter/selectProjectCenterTwo',
    method: 'post',
    data
  })
}

// 所有项目经理
export function getProjectManager(data) {
  return request({
    url: '/projectCenter/getProjectManager',
    method: 'get',
    params: data
  })
}

// 新版-新增
export function saveProject(data) {
  return request({
    url: '/projectCenter/saveProject',
    method: 'post',
    data
  })
}

// 新版-新增
// export function saveProjectTwo(data) {
//   return request({
//     url: '/projectCenter/saveProjectTwo',
//     method: 'get',
//     params: data
//   })
// }

// 修改项目经理
export function updateProjectManager(data) {
  return request({
    url: '/projectCenter/updateProjectManager',
    method: 'post',
    data
  })
}

// 新版-查询单个
export function selectProjectBYId(data) {
  return request({
    url: '/projectCenter/selectProjectBYId',
    method: 'GET',
    params: data
  })
}

// 新版-修改
export function updateProject(data) {
  return request({
    url: '/projectCenter/updateProject',
    method: 'POST',
    data
  })
}

// 寻访方案一览与详情
export function getSearch(data) {
  return request({
    url: '/projectCenter/getSearch',
    method: 'POST',
    data
  })
}

// 新增寻访方案
export function saveSearch(data) {
  return request({
    url: '/projectCenter/saveSearch',
    method: 'POST',
    data
  })
}

// 查询沟通列表
export function selectIntermediate(data) {
  return request({
    url: '/projectCenter/selectIntermediate',
    method: 'POST',
    data
  })
}

// 新增信息
export function saveMessage(data) {
  return request({
    url: '/message/saveMessage',
    method: 'POST',
    data
  })
}

// 用于人才中心添加候选人使用
export function listPerson(data) {
  return request({
    url: '/projectCenter/listPerson',
    method: 'POST',
    data
  })
}

// 添加沟通列表（多个）
export function saveIntermediateList(data) {
  return request({
    url: '/projectCenter/saveIntermediateList',
    method: 'POST',
    data
  })
}

// 人才es查询
export function getHomePage(data) {
  return request({
    url: '/person/getHomePage',
    method: 'POST',
    data
  })
}

// 添加
export function save(data) {
  return request({
    url: '/CandidateRecords/save',
    method: 'POST',
    data
  })
}

// 查询人才是否已存在本项目中
export function selectExist(data) {
  return request({
    url: '/projectCenter/selectExist',
    method: 'get',
    params: data
  })
}

// 添加沟通列表（多个人才）
export function saveIntermediateListTwo(data) {
  return request({
    url: '/projectCenter/saveIntermediateListTwo',
    method: 'post',
    data
  })
}

// 添加沟通列表（多个人才） 去掉候选列表改的接口
export function insertPersonNew(data) {
  return request({
    url: '/person/insertPersonNew',
    method: 'post',
    data
  })
}

// 添加沟通列表(单个)
export function saveIntermediate(data) {
  return request({
    url: '/projectCenter/saveIntermediate',
    method: 'post',
    data
  })
}

// 修改沟通列表(单个)
export function updateIntermediate(data) {
  return request({
    url: '/projectCenter/updateIntermediate',
    method: 'post',
    data
  })
}
//批量删除人才与项目的关联关系
export function deleteIntermediateTwo(data) {
  return request({
    url: '/CandidateRecords/deleteIntermediateTwo',
    method: 'post',
    data
  })
}
// //档案一览
export function getArchivesCenter(data) {
  return request({
    url: '/projectCenter/getArchivesCenter',
    method: 'post',
    data
  })
}

//批量删除/删除档案
export function deleteArchivesCenter(data) {
  return request({
    url: '/projectCenter/deleteArchivesCenter',
    method: 'post',
    data
  })
}

//  后台文件公共上传
export function uploadAdmin(data) {
  return request({
    url: '/upload/uploadAdmin',
    method: 'post',
    data
  })
}

// 新增档案
export function saveArchivesCenter(data) {
  console.log("data", data);
  return request({
    url: '/projectCenter/saveArchivesCenter',
    method: 'post',
    data
  })
}

// 后台文件公共下载(单个)
export function uploadFile(data) {
  return request({
    url: '/upload/uploadFile',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}

//修改档案
export function updateArchivesCenter(data) {
  return request({
    url: '/projectCenter/updateArchivesCenter',
    method: 'post',
    data
  })
}

// 查询一览（可根据项目id查询）
export function selectScriptManagement(data) {
  return request({
    url: '/ScriptManagementService/selectScriptManagement',
    method: 'get',
    params: data
  })
}

// 删除
export function removeDelete(data) {
  return request({
    url: '/ScriptManagementService/delete',
    method: 'get',
    params: data
  })
}

// 新增
export function addSave(data) {
  return request({
    url: '/ScriptManagementService/save',
    method: 'post',
    data
  })
}

// 修改 /ScriptManagementService/update
export function update(data) {
  return request({
    url: '/ScriptManagementService/update',
    method: 'post',
    data
  })
}

// 批量删除候选人
export function deleteIntermediate(data) {
  return request({
    url: '/projectCenter/deleteIntermediate',
    method: 'post',
    data
  })
}

// 查询一览
export function selectCandidateRecords(data) {
  return request({
    url: '/CandidateRecords/selectCandidateRecords',
    method: 'post',
    data
  })
}

// 根据id查询人才详情信息
export function getParticularsPersonByid(data) {
  return request({
    url: '/person/getParticularsPersonByid',
    method: 'GET',
    params: data
  })
}

// 查单个
export function selectByid(data) {
  return request({
    url: '/talentRecommendationReport/selectByid',
    method: 'GET',
    params: data
  })
}

// 人才推荐报告下载
export function reportDownLoad(data) {
  return request({
    url: '/wordDownLoad/reportDownLoad',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}

// 项目JD下载
export function projectCenterReportDownLoad(data) {
  return request({
    url: '/projectCenter/reportDownLoad',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}

// 查询单个
export function BackgroundInvestigationReport(data) {
  return request({
    url: '/BackgroundInvestigationReport/selectById',
    method: 'get',
    params: data
  })
}

// /BackgroundInvestigationReport/save
export function BackgroundInvestigationReportSave(data) {
  return request({
    url: '/BackgroundInvestigationReport/save',
    method: 'post',
    data
  })
}

// 项目寻访方案下载
export function projectLookFor(data) {
  return request({
    url: '/projectCenter/projectLookFor',
    method: 'GET',
    params: data,
    responseType: 'blob'
  })
}

// 背景调查报告下载
export function backgroundInvestigationReport(data) {
  return request({
    url: '/projectCenter/backgroundInvestigationReport',
    method: 'GET',
    params: data,
    responseType: 'blob'
  })
}

// 客户中心 客户中心一览(带分页)(带分页)
export function getClient(data) {
  return request({
    url: '/clue/getClient',
    method: 'post',
    data
  })
}

// 统计候选人列表/沟通列表
export function listCount(data) {
  return request({
    url: '/projectCenter/listCount',
    method: 'GET',
    params: data
  })
}

// 统计候选人列表/沟通列表
export function projectCenterDeleteById(data) {
  return request({
    url: '/projectCenter/deleteById',
    method: 'GET',
    params: data
  })
}

// 上下架项目
export function projectShelf(data) {
  return request({
    url: '/projectCenter/projectShelf',
    method: 'GET',
    params: data
  })
}


// 工作台-沟通列表


//  新增人才进度
export function saveCandidateRecords(data) {
  return request({
    url: '/CandidateRecords/save',
    method: 'post',
    data
  })
}
//  修改人才进度
export function updateCandidateRecords(data) {
  return request({
    url: '/CandidateRecords/update',
    method: 'post',
    data
  })
}
// 查看当前人才进度详情
export function getPersonProgressById(data) {
  return request({
    url: '/CandidateRecords/listById',
    method: 'GET',
    params: data
  })
}
// 模糊查询面试官
export function selectInterviewer(data) {
  return request({
    url: '/CandidateRecords/selectInterviewer',
    method: 'GET',
    params: data
  })
}
// 新增面试官
export function addInterviewer(data) {
  return request({
    url: '/CandidateRecords/addInterviewer',
    method: 'GET',
    params: data
  })
}

// 根据项目id、人才code、人才进度查询人才进度id
export function selectPersonScheduleId(data) {
  return request({
    url: '/CandidateRecords/selectPersonScheduleId',
    method: 'GET',
    params: data
  })
}
// 根据时间计算是否入职并入职多少天
export function computeDayNumber(data) {
  return request({
    url: '/CandidateRecords/computeDayNumber',
    method: 'GET',
    params: data
  })
}
// 删除人才与项目的关联关系  新增、编辑人才进度弹窗
export function deletePersonRelateProject(data) {
  return request({
    url: '/CandidateRecords/deleteIntermediate',
    method: 'GET',
    params: data
  })
}
//人选一览
export function selectPersonChosen(data) {
  return request({
    url: '/projectCenter/selectPersonChosen',
    method: 'post',
    data
  })
}
//修改人选备注
export function updateCandidateRemarks(data) {
  return request({
    url: '/projectCenter/updateCandidateRemarks',
    method: 'GET',
    params: data
  })
}

// 查询客户经理 /projectCenter/getCustomerManager
export function updategetCustomerManager() {
  return request({
    url: '/projectCenter/getCustomerManager',
    method: 'GET'
  })
}
// 修改客户经理  /projectCenter/updateCustomerManager
export function selectUpdateCustomerManager(data) {
  return request({
    url: '/projectCenter/updateCustomerManager',
    method: 'post',
    data
  })
}

//查询项目状态条数 /projectCenter/selectProjectCenterTwo/number
export function selectProjectCenterNumber(data) {
  return request({
    url: '/projectCenter/selectProjectCenterTwo/number',
    method: 'post',
    data
  })
}

//查询人选状态条数 /selectPersonChosen/number
export function selectPersonChosenNumber(data) {
  return request({
    url: '/projectCenter/selectPersonChosen/number',
    method: 'post',
    data
  })
}


// 沟通列表移除候选人
// export function deleteByTwoId(data) {
//   return request({
//     url: '/CandidateRecords/deleteByTwoId',
//     method: 'GET',
//     params: data
//   })
// }
